<template>
  <div>
    <label>{{ localize.KZ_COMPONENTS_DADATA_LOCATION_TITLE }}</label>
    <div class="dadata-wrapper cities">
      <input
          :value="cityValue"
          ref="city-input"
          class="search-suggest dadata"
          type="text"
          autocomplete="off"
          :placeholder=localize.KZ_COMPONENTS_DADATA_TITLE_LOCATION_PLACEHOLDER
      >
    </div>
  </div>
</template>

<script>
import 'suggestions-jquery';

export default {
  props: {
    cityValue: String,
  },
  data: () => ({
    address: '',
    token: '132554ee7e4d1a569575bb8bc79b18008734d80f',
  }),
  computed: {
    localize() {
      return BX.Vue.getFilteredPhrases('KZ_COMPONENTS_');
    }
  },
  mounted() {
    this.address = $(this.$store.addressInput);
    this.$store.cityInput = $(this.$refs['city-input']);

    $(this.$refs['city-input']).suggestions({
      token: this.token,
      type: "ADDRESS",
      hint: false,
      bounds: 'city-settlement',
      onSelect: (suggestion) => {
        this.$emit('select', suggestion);
      },
    })
  },
};
</script>

<style>
.dadata-wrapper {
  position: relative;
  width: 100%;
}

.dadata-wrapper .dadata {
  width: 100%;
}

.suggestions-wrapper {
  width: 100%;
  position: absolute !important;
  top: 33px;
  max-width: 340px;
}

.suggestions-promo {
  display: none;
}
</style>